import { cn } from '@/ui/utils'
import type { PropsWithChildren } from 'react'
import { Text as RNText, View } from 'react-native'

const HighlightText = ({
	className,
	textClassName,
	children,
}: PropsWithChildren & { className?: string; textClassName?: string }) => {
	return (
		<View
			className={cn(
				'flex align-middle justify-center items-center w-fit rounded-sm bg-palette_10 px-3 py-1',
				className
			)}
		>
			<RNText
				className={cn(
					'font-primary-bold text-sm uppercase text-black tracking-widest',
					textClassName
				)}
			>
				{children}
			</RNText>
		</View>
	)
}

export { HighlightText }
